import React, { PureComponent } from "react";
import { connect } from "react-redux";

import { TxActions } from "src/redux/Tx/actions";
import Actions from "./Actions";
import Table from "./Table";

import styles from "./styles.module.scss";
import { TxSelectors } from "src/redux/Tx/selectors";
import { TopBarSelectors } from "src/redux/TopBar/selectors";
import { ROLE } from "src/redux/TopBar/constants";

class Preview extends PureComponent {
    handleSend = () => {
        // Suspend refresh during http request
        // Chrome won't allow custom message
        window.onbeforeunload = () =>
            "Are you sure you want to refresh? On-going request will be canceled or finished abnormally";

        // Check if data has group structure (portfolio transaction)
        const hasGroupStructure = this.props.createRowData.some(
            (row) => row.parentId !== undefined
        );

        let send;
        if (hasGroupStructure) {
            send = this.props.sendPortfolioInitiate;
        } else {
            send =
                this.props.role === ROLE.LENDER
                    ? this.props.sendLenderOffer
                    : this.props.sendBorrowerInit;
        }

        send().then(() => {
            // reset refresh suspension
            window.onbeforeunload = undefined;
        });
    };

    render() {
        return (
            <div className={styles.txPreview}>
                <Table />
                <Actions handleSend={this.handleSend} />
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    sendBorrowerInit: () => dispatch(TxActions.SendInitiate()),
    sendLenderOffer: () => dispatch(TxActions.SendOffer()),
    sendPortfolioInitiate: () => dispatch(TxActions.SendPortfolioInitiate()),
});

const mapStateToProps = (state) => ({
    sendingState: TxSelectors.TxInitState(state),
    sendingStateError: TxSelectors.TxInitStateError(state),
    role: TopBarSelectors.Role(state),
    createRowData: TxSelectors.TxInitRowData(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(Preview);
